// extracted by mini-css-extract-plugin
export const services = "C_b3";
export const services_content = "C_b4";
export const services_descr = "C_b5";
export const services_title = "C_b6";
export const services_list = "C_b7";
export const services_item = "C_b8";